import { Directive, Input, ElementRef, SimpleChanges, OnInit, OnChanges } from '@angular/core';
import { interpolateColors } from '../redux/services/utils/color-interpolation';

@Directive({
 standalone: false, selector: 'canvas[appDoughnutChart]', exportAs: 'doughnut-chart' })
export class DoughnutChartDirective implements OnInit, OnChanges {
  @Input() values: number[];
  @Input() drawConfig: {
    startX?: number;
    startY?: number;
    lineWidth?: number;
    radius?: number;
    offset?: number; // degree in Radians
    colors?: number[][]; // arrays of [r,g,b,a]
  };
  ctx: CanvasRenderingContext2D;
  private readonly defaults = {
    startX: 60,
    startY: 60,
    lineWidth: 12,
    radius: 49,
    offset: 0.03,
    colors: [
      [0, 8, 53, 1],
      [58, 139, 255, 1],
      [197, 213, 249, 1],
      [235, 243, 255, 1]
    ]
  };
  private readonly element: ElementRef;
  // angle cache between draws
  private startAngle: number;
  private initFlag = false;

  constructor(element: ElementRef) {
    this.element = element;
  }

  ngOnInit() {
    this.drawConfig = this.drawConfig || {};
    this.ctx = this.element.nativeElement.getContext('2d');
    this.initFlag = true;
    this.draw();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      this.initFlag &&
      (Object.prototype.hasOwnProperty.call(changes, 'drawConfig') ||
        Object.prototype.hasOwnProperty.call(changes, 'values'))
    ) {
      this.draw();
    }
  }

  private drawArc(value: number, color: string, active: boolean) {
    let radius = this.getConfigValue('radius');
    let lineWidth = this.getConfigValue('lineWidth');
    const offset = this.getConfigValue('offset');

    // values over 50% does not look nice when highlighted
    if (active && value < 0.5) {
      lineWidth = 16;
      radius = 51;
      this.ctx.shadowColor = 'rgba(0,0,0,.4)';
      this.ctx.shadowBlur = 4;
      this.ctx.shadowOffsetX = 2;
      this.ctx.shadowOffsetY = 2;
    } else {
      this.ctx.shadowBlur = 0;
      this.ctx.shadowOffsetX = 0;
      this.ctx.shadowOffsetY = 0;
    }
    let endAngle = this.startAngle + value * 2 * Math.PI;
    // start angle can not be bigger than end angle
    if (value * Math.PI * 2 > offset) {
      endAngle -= offset;
    }

    this.ctx.beginPath();
    this.ctx.strokeStyle = color;
    this.ctx.lineWidth = lineWidth;
    this.ctx.arc(this.getConfigValue('startX'), this.getConfigValue('startY'), radius, this.startAngle, endAngle);
    this.ctx.stroke();
    this.startAngle = endAngle + offset;
  }

  private draw() {
    if (!this.values) {
      return;
    }
    this.ctx.clearRect(0, 0, this.element.nativeElement.width, this.element.nativeElement.height);
    this.startAngle = -this.values[0] * Math.PI;
    const colors = interpolateColors(this.values.length, this.getConfigValue('colors')).map(
      colorArray => 'rgba(' + colorArray.join(',') + ')'
    );

    this.values.forEach((v, i) => {
      this.drawArc(v, colors[i], 0 === i);
    });
  }

  private getConfigValue(key: string): any {
    return typeof this.drawConfig[key] !== 'undefined' ? this.drawConfig[key] : this.defaults[key];
  }
}
